import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, InputGroup, Badge } from 'react-bootstrap';
import { apiFetch } from '../../../utils/api';
import ImageCropper from '../../../components/cropper/ImageCropper';

export default function ModalWindow({show, handleClose, formData, handleChange, handleSubmit, handleImage, title}) {
  const [categories, setCategories] = useState([]);
  
  // Состояния для редактора фото
  const [imageSrc, setImageSrc] = useState(null);
  const [cropSuccess, setCropSuccess] = useState(false);

  useEffect(() => {
    if (show) {
      apiFetch('/api/categories').then(res => res.json()).then(setCategories);
      setCropSuccess(false);
      setImageSrc(null);
    }
  }, [show]);

  // Загружаем файл во временную память браузера для редактирования
  const onFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setImageSrc(reader.result); // Показываем редактор
        setCropSuccess(false);
      };
    }
  };

  // Если фото выбрано, показываем вместо формы наш редактор
  if (imageSrc) {
    return (
      <Modal show={show} onHide={() => setImageSrc(null)} centered size="lg" backdrop="static">
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="fw-bold">Кадрирование фото (Каталог)</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 pb-4">
          <ImageCropper 
            imageSrc={imageSrc} 
            aspect={4/3} // Пропорция для карточек каталога
            onCancel={() => setImageSrc(null)}
            onCropDone={(file) => {
              // Имитируем event, который ожидает handleImage
              handleImage({ target: { files: [file] } });
              setImageSrc(null);
              setCropSuccess(true);
            }}
          />
        </Modal.Body>
      </Modal>
    );
  }

  // Обычная форма
  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="fw-bold">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4">
        <Form>
          <Form.Group className="mb-3">
            <Form.Label className="small fw-bold text-muted text-uppercase">Название услуги</Form.Label>
            <Form.Control name='title' value={formData.title} onChange={handleChange} placeholder="Укладка брусчатки..." className="bg-light border-0 py-2 shadow-none" required/>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="small fw-bold text-muted text-uppercase">Категория</Form.Label>
            <Form.Select name="category_id" value={formData.category_id || ''} onChange={handleChange} className="border-0 bg-light py-2 shadow-none" required>
              <option value="">-- Выберите категорию --</option>
              {categories.map(cat => (
                <option key={cat.id} value={cat.id}>{cat.name}</option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="small fw-bold text-muted text-uppercase">Описание</Form.Label>
            <Form.Control as='textarea' rows={4} name='description' value={formData.description} onChange={handleChange} className="bg-light border-0 py-2 shadow-none" required/>
          </Form.Group>

          <Form.Label className="small fw-bold text-muted text-uppercase">Стоимость</Form.Label>
          <InputGroup className="mb-3 shadow-none">
            <InputGroup.Text className="bg-light border-0 text-muted">₽</InputGroup.Text>
            <Form.Control name='price' type="number" value={formData.price} onChange={handleChange} className="bg-light border-0 py-2 shadow-none" required/>
          </InputGroup>

          <Form.Group className="mb-3">
            <Form.Label className="small fw-bold text-muted text-uppercase d-block">Фотография</Form.Label>
            <div className="d-flex align-items-center gap-3">
              <Form.Control type="file" accept='image/*' onChange={onFileChange} className="bg-light border-0 shadow-none"/>
              {cropSuccess && <Badge bg="success" className="px-3 py-2">Фото обработано <i className="bi bi-check-circle ms-1"></i></Badge>}
            </div>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className="border-0">
        <Button variant="light" onClick={handleClose}>Отмена</Button>
        <Button className="btn-corp" onClick={handleSubmit}>Сохранить</Button>
      </Modal.Footer>
    </Modal>
  );
}
